import React from 'react';
import { Tabs } from 'antd';
import ComponentsManager from '../components/Components/ComponentsManager';
import DynamicTables from '../components/Components/DynamicTables';
import ColorSystem from '../components/Components/ColorSystem';

const Components = () => {
    const items = [
        {
            key: '1',
            label: 'Global Components',
            children: <ComponentsManager />,
        },
        {
            key: '2',
            label: 'Dynamic Tables',
            children: <DynamicTables />,
        },
        {
            key: '3',
            label: 'Color System',
            children: <ColorSystem />,
        }
    ];

    return (
        <Tabs
            defaultActiveKey="1"
            items={items}
            style={{
                padding: 'clamp(0.5rem, 1.5vw, 1rem)',
                fontSize: 'clamp(0.875rem, 1.6vw, 1rem)'
            }}
        />
    );
};

export default Components; 